import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { XCloseIcon } from '@rsos/assets/icons';
import { Box, Button, Text } from '@rsos/base-components';
import { CloseButton as DCCloseButton } from '@rsos/components/capstone/DataCards/DataCards.styles';
import EventPaneBanner from '../../../EventPaneBanner';
import {
  LATEST_SUMMARY_INDEX,
  selectTranscriptionForCall,
} from '../transcriptionSlice';
import { TightStyledSmartLink } from './TranscriptFeedback.styles';
import TranscriptFeedbackModal from './TranscriptFeedbackModal';
import type { RootState } from './types';
import { useTranscriptFeedbackApi } from './useTranscriptFeedbackApi';

interface TranscriptFeedbackProps {
  callerId: string;
}

export const CloseButton = styled(DCCloseButton)`
  margin-left: 7px;
  height: 20px;
`;

function TranscriptFeedback({ callerId }: TranscriptFeedbackProps) {
  const [show, setShow] = useState(true);
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const isInternalFeedbackEnabled = useTranscriptFeedbackApi();

  const summaries = useSelector(
    (state: RootState) =>
      selectTranscriptionForCall(callerId)(state)?.summaries || [],
  );

  const isSummaryFinished = summaries[LATEST_SUMMARY_INDEX]?.is_final || false;

  if (!show) {
    return null;
  }

  if (!isInternalFeedbackEnabled && (!isSummaryFinished || !callerId)) {
    return null;
  }

  return (
    <>
      <EventPaneBanner padding="0px 20px">
        <Box horizontal justify="space-between" align="center" width="100%">
          <Text size="normal" color="background">
            How did Harmony AI perform?
          </Text>
          <Box horizontal align="center" flow={8}>
            {isInternalFeedbackEnabled ? (
              <Button
                btnType="secondary"
                size="small"
                onClick={() => setIsFeedbackModalOpen(true)}
              >
                Send Feedback
              </Button>
            ) : (
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore - StyledSmartLink typing issue
              <TightStyledSmartLink
                data-name="navigation-control-give-feedback-link"
                type="standalone"
              >
                <Button btnType="secondary" size="small">
                  Send Feedback
                </Button>
              </TightStyledSmartLink>
            )}
            <CloseButton
              onClick={() => setShow(false)}
              data-testid="close-banner-button"
            >
              <XCloseIcon color="background" />
            </CloseButton>
          </Box>
        </Box>
      </EventPaneBanner>

      {isInternalFeedbackEnabled && (
        <TranscriptFeedbackModal
          isOpen={isFeedbackModalOpen}
          onClose={() => setIsFeedbackModalOpen(false)}
          callerId={callerId}
        />
      )}
    </>
  );
}

export default TranscriptFeedback;
